const formatter = new Intl.NumberFormat("ja-JP");

export const formatCurrency = (v) => {
  if (v === "-") {
    return v;
  }
  return formatter.format((+v).toFixed(0));
};
